import { z } from 'zod'

export const UsernameSchema = z
  .string({ required_error: 'Username is required' })
  .min(3, { message: 'Username is too short' })
  .max(20, { message: 'Username is too long' })
  .regex(/^[a-zA-Z0-9_-]+$/, {
    message:
      'Username can only include letters, numbers, underscores, and hyphens',
  })
  // users can type the username in any case, but we store it in lowercase
  .transform(value => value.toLowerCase())

export const PasswordSchema = z
  .string({ required_error: 'Password is required' })
  .min(1, { message: 'Password is required' })

export const StrongPasswordSchema = z
  .string({ required_error: 'Password is required' })
  .min(12, { message: 'Password must be at least 12 characters long' })
  .max(128, { message: 'Password must be at most 128 characters long' })
  .refine(
    password =>
      /[A-Z]/.test(password) && // uppercase
      /[a-z]/.test(password) && // lowercase
      /[0-9]/.test(password), // number
    {
      message:
        'Password must include uppercase, lowercase letters and a number',
    },
  )

export const STRONG_PASSWORD_HINT =
  'At least 12 characters with uppercase, lowercase and a number'
export const NameSchema = z
  .string({ required_error: 'Name is required' })
  .min(3, { message: 'Name is too short' })
  .max(40, { message: 'Name is too long' })

export const EmailSchema = z
  .string({ required_error: 'Email is required' })
  .email({ message: 'Email must be a valid email address' })
  .min(3, { message: 'Email is too short' })
  .max(254, { message: 'Email is too long' })
  // users can type the email in any case, but we store it in lowercase
  .transform(value => value.toLowerCase().trim())

export const PasswordAndConfirmPasswordSchema = z
  .object({
    password: StrongPasswordSchema,
    confirmPassword: StrongPasswordSchema,
  })
  .superRefine(({ confirmPassword, password }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        path: ['confirmPassword'],
        code: 'custom',
        message: 'The passwords must match',
      })
    }
  })
